import { defineStore } from 'pinia'
import Axios from 'axios'
import { useProcessoParadigmaStore } from "@/store/processoparadigma-store"

const BASE_URL = process.env.VUE_APP_BASE_URL || window.location.origin + "/"
const TEMA_URL = BASE_URL + "api/demandasrepetitivas/enunciado"
export const useEnunciadoStore = defineStore('enunciado', {
  state: () => ({
    temas: {},
    temasCount: 0,
    pages: {},
    tema: {},
    stgTema: {},

    numProcessoPJe: "",
    numeroUnicoTema: "",
    texto: "",
    situacao: 0,
    numeroProcesso: "",
    page: 1,
  }),
  getters: {
    all: state => state.temas,
  },
  actions: {
    async resetPagination() {
      this.pages = {}
    },
    async clearStg() {
      this.stgTema = {
        linkAcordaos: null,
        referenciaLegislativa: null,
        idTipoEnunciado: null,
        dataCriacao: null,
        dataSituacaoEnunciado: null,
        idSituacaoEnunciado: null,
        texto: null,
        numero: "",
        statusEnvioBnp: false,
        processosparadigma: []
      }
    },
    async fetchStg(id) {
      const tema = await this.fetch(id)
      Object.assign(this.stgTema, tema);
      return this.stgTema
    },
    async fetch(id) {
      const { data } = await Axios.get(TEMA_URL + "/" + id)
      const { enunciado } = data
      this.temas = {
        ...this.temas, ...Object.fromEntries([[enunciado.numero, enunciado]])
      }
      return enunciado

    },
    async fetchPage(page, rowsPerPage) {
      this.page = page || this.page || 1;
      this.rowsPerPage = rowsPerPage || this.rowsPerPage || 10;
      const { data } = await Axios.get(TEMA_URL + "?page=" + this.page + "&itensporpagina=" + this.rowsPerPage + "&numProcessoPJe=" + this.numProcessoPJe + "&numeroUnicoTema=" + this.numeroUnicoTema + "&idSituacaoTema=" + this.situacao + "&descricao=" + this.texto)
      const { listaDeEnunciado, meta } = data
      this.temasCount = meta.totalEnunciado;
      this.pages[`${this.page}`] = listaDeEnunciado
      return listaDeEnunciado
    },
    async saveStg() {
      const fields = [
        "linkAcordaos",
        "referenciaLegislativa",
        "idTipoEnunciado",
        "dataCriacao",
        "dataSituacaoEnunciado",
        "idSituacaoEnunciado",
        "texto",
        "numero",
        "processosParadigma",
        "statusEnvioBnp",
      ];

      const filterFields = obj =>
        Object.fromEntries(
          Object.entries(obj).filter(e => fields.includes(e[0]))
        );
      const procStore = useProcessoParadigmaStore()
      const payload = filterFields({ ...this.stgTema, processosParadigma: procStore.all });
      const result = payload.numero ? await Axios.put(TEMA_URL, payload) : await Axios.post(TEMA_URL, payload)
      return result
    }
  },
})
